import React from 'react';
import { Target, Edit, X, Plus, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const HealthGoalsSection = ({
  editedData,
  isEditing,
  onToggleEdit,
  onCancelEdit,
  onAddGoal,
  onUpdateGoal,
  onRemoveGoal
}) => {
  return (
    <div className="mb-6">
      <div className="card border-2 border-green-200 bg-gradient-to-br from-white to-green-50 shadow-lg">
        <div className="flex items-center justify-between mb-4 pb-2 border-b-2 border-green-100">
          <h2 className="text-xl font-semibold text-slate-900 flex items-center gap-2">
            <Target size={20} className="text-green-600" />
            Health Goals
          </h2>
          {!isEditing ? (
            <Button onClick={onToggleEdit} className="btn-secondary" data-testid="health-goals-edit-btn">
              <Edit size={16} className="mr-2" />
              Edit
            </Button>
          ) : (
            <div className="flex gap-2">
              <Button onClick={onAddGoal} className="btn-secondary text-sm" data-testid="health-goals-add-btn">
                <Plus size={16} className="mr-1" />
                Add Goal
              </Button>
              <Button onClick={onCancelEdit} className="btn-ghost text-red-600" data-testid="health-goals-cancel-btn">
                <X size={16} className="mr-2" />
                Cancel
              </Button>
            </div>
          )}
        </div>

        {!isEditing ? (
          <div className="space-y-3">
            {editedData.health_goals?.map((goal) => (
              <div key={goal.id} className="p-4 bg-white rounded-lg border border-green-200">
                <h3 className="font-semibold text-slate-900 mb-2">{goal.category}</h3>
                <p className="text-slate-700">{goal.description}</p>
              </div>
            ))}
            {(!editedData.health_goals || editedData.health_goals.length === 0) && (
              <p className="text-slate-500 italic">No health goals set</p>
            )}
          </div>
        ) : (
          <div className="space-y-4">
            {editedData.health_goals?.map((goal, index) => (
              <div key={goal.id} className="p-4 bg-white rounded-lg border border-green-200">
                <div className="flex justify-between items-start mb-3">
                  <h3 className="font-semibold text-slate-900">Goal {index + 1}</h3>
                  <Button
                    onClick={() => onRemoveGoal(index)}
                    className="btn-ghost text-red-600 text-xs"
                    data-testid={`health-goal-remove-btn-${index}`}
                  >
                    <Trash2 size={14} />
                  </Button>
                </div>
                <div className="space-y-3">
                  <div>
                    <Label className="text-xs">Category</Label>
                    <Input
                      value={goal.category}
                      onChange={(e) => onUpdateGoal(index, 'category', e.target.value)}
                      placeholder="e.g., Weight Loss, Exercise"
                      className="mt-1"
                      data-testid={`health-goal-category-${index}`}
                    />
                  </div>
                  <div>
                    <Label className="text-xs">Description</Label>
                    <Textarea
                      value={goal.description}
                      onChange={(e) => onUpdateGoal(index, 'description', e.target.value)}
                      placeholder="Describe the health goal..."
                      className="mt-1"
                      rows={3}
                      data-testid={`health-goal-description-${index}`}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default HealthGoalsSection;
